module.exports = __webpack_public_path__ + "img/1F1F5-1F1EB.b3cc1c5b.svg";